import { render, staticRenderFns } from "./index.vue?vue&type=template&id=475affc6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=475affc6&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475affc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('475affc6')) {
      api.createRecord('475affc6', component.options)
    } else {
      api.reload('475affc6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=475affc6&scoped=true", function () {
      api.rerender('475affc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/technicalQA/index.vue"
export default component.exports